import { Skeleton } from 'primereact/skeleton';

const NDCListLoader = () => {
  return (
    <div>
      <Skeleton width="38rem" height="80vh"></Skeleton>
    </div>
  );
};

export default NDCListLoader;
